import { render, staticRenderFns } from "./moreAdvertiseMent.vue?vue&type=template&id=0bf840e4&scoped=true"
import script from "./moreAdvertiseMent.vue?vue&type=script&lang=js"
export * from "./moreAdvertiseMent.vue?vue&type=script&lang=js"
import style0 from "./moreAdvertiseMent.vue?vue&type=style&index=0&id=0bf840e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf840e4",
  null
  
)

export default component.exports